// Íconos en línea. Son pocos y chicos: no vale la pena una dependencia.
const trazo = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

export const Flecha = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

export const FlechaDerecha = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <path d="M9 18l6-6-6-6" />
  </svg>
);

export const Tilde = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

export const Alerta = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v5M12 16h.01" />
  </svg>
);

export const Campana = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <path d="M18 16V11a6 6 0 0 0-12 0v5l-1.5 2.5h15L18 16z" />
    <path d="M10 19a2 2 0 0 0 4 0" />
  </svg>
);

export const Calendario = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M8 3v4M16 3v4M3.5 10h17" />
  </svg>
);

export const Reloj = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3.2 2" />
  </svg>
);

export const Buscar = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </svg>
);

export const SinSenal = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <path d="M3 3l18 18" />
    <path d="M8.5 16.4a5 5 0 0 1 7 0M5 12.9a10 10 0 0 1 4-2.4M19 12.9a10 10 0 0 0-6-2.8" />
    <path d="M12 20h.01" />
  </svg>
);

export const WhatsApp = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm5.8 14.2c-.2.7-1.4 1.3-2 1.4-.5.1-1.1.1-1.8-.1-.4-.1-1-.3-1.7-.6-2.9-1.3-4.8-4.3-5-4.5-.1-.2-1.1-1.5-1.1-2.8 0-1.3.7-2 .9-2.2.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.3 0 .5l-.4.5-.3.3c-.1.1-.2.3 0 .5.1.2.6 1.1 1.4 1.8 1 .9 1.8 1.1 2 1.2.2.1.4.1.5-.1l.7-.9c.2-.2.3-.2.5-.1l2 .9c.2.1.4.2.4.3.1.2.1.6 0 1.2Z" />
  </svg>
);

export const Descargar = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <path d="M12 3v12M7.5 10.5L12 15l4.5-4.5" />
    <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
  </svg>
);

export const Sobre = (props) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...trazo} {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3.5 7 8.5 6 8.5-6" />
  </svg>
);
